import {
  IPracticeSetupStep,
  PracticeSetupStepStatus,
} from '@principle-theorem/principle-core/interfaces';
import { AtLeast } from '@principle-theorem/shared';

export class PracticeSetupStep {
  static init(
    overrides: AtLeast<
      IPracticeSetupStep,
      'id' | 'category' | 'title' | 'description'
    >
  ): IPracticeSetupStep {
    return {
      status: PracticeSetupStepStatus.NotStarted,
      validationPassed: false,
      deleted: false,
      pageVisits: [],
      ...overrides,
    };
  }
}
